// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__105sh","colMin":"styles_colMin__3EeTv","colCheckbox":"styles_colCheckbox__-Hu-S"};